@if (!noHeader) {
  @if (hideHeader) {
    <app-unlogged-header />
  } @else {
    <app-header />
  }
}

<main class="atalaya" [ngClass]="{ 'no-padding': disablePadding, scrollable: scrollable }">
  <app-loading></app-loading>
  <router-outlet></router-outlet>
</main>

<app-modal />
<app-toast />
